export default __webpack_public_path__ + "static/media/addDishInputIcon.f72a05ea.svg";